import { useContext } from "react";
import dynamic from "next/dynamic";
import { Store } from "@store";
import { ViewSinglePostModalProvider } from "@components/context/ViewSinglePostModal";
import { VIEWTYPES } from "@utils/constants";
import Carousel from "@components/carousel/Carousel";
import Post from "../../src/socialMediaModule/components/post";
// import Trending from "@components/post/TrendingHashtags";

/* ----------------------- client-side imports ---------------------------- */

const CreatePost = dynamic(() => import("@components/createPost/CreatePost"), {
  ssr: false
});
const Clips = dynamic(() => import("./Clips"), {
  ssr: false
});
const RecentlyVisited = dynamic(() => import("./RecentlyVisited"), {
  ssr: false
});
const Festivals = dynamic(() => import("./Festivals"), {
  ssr: false
});
const YoutubeClips = dynamic(() => import("./YoutubeClips"), {
  ssr: false
});
const GridList = dynamic(() => import("./GridList"), {
  ssr: false
});
const GridList1 = dynamic(() => import("./GridList1"), {
  ssr: false
});
// const LinearList = dynamic(() => import("./LinearList"), {
//   ssr: false,
// });
// const PeoplesPost = dynamic(() => import("./PeoplesPost"), {
//   ssr: false,
// });
const Timer = dynamic(() => import("./Timer"), {
  ssr: false
});
const FestivalTimeline = dynamic(() => import("./FestivalTimeline"), {
  ssr: false
});
const RelatedPostsText = dynamic(() => import("./RelatedPostsText"), {
  ssr: false
});

/* ------------------------------------------------------------------------ */

export default function RenderPosts({
  data,
  functions,
  postType
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  function getFeedItem(item, index) {
    const viewType = item.viewType;
    switch (viewType) {
      // case VIEWTYPES.LINEARLIST:
      // -------------not in use currently----------
      //   return <LinearList key={index.toString()} data={item} />;

      case VIEWTYPES.CREATEPOST:
        if (loggedInUser.authType) return <CreatePost key={index.toString()} />;else return null;
      case VIEWTYPES.CAROUSEL:
        return <Carousel key={index.toString()} data={item.bannerModels || item.response} />;
      case VIEWTYPES.GRIDLIST:
        if (item.viewName.toLowerCase() === "recently visited") {
          return <RecentlyVisited key={index.toString()} data={item} />;
        } else {
          return <GridList key={index.toString()} data={item.mainElementModels[0]} />;
        }
      case VIEWTYPES.GRIDLIST1:
        if (item.viewName.toLowerCase() === "recently visited") {
          return <RecentlyVisited key={index.toString()} data={item} />;
        } else {
          return <GridList1 key={index.toString()} data={item} />;
        }
      case VIEWTYPES.CLIPS_HOME:
        if (functions?.setReelNewTs && item.lastClipTs) functions.setReelNewTs(item.lastClipTs);
        return <Clips key={index.toString()} data={item} />;
      case VIEWTYPES.CLIPS_PROFILE:
        if (functions?.setPostNewTs && item.lastClipTs) functions.setPostNewTs(item.lastClipTs);
        return <Post key={index.toString()} postData={item.feedPostModel || item.response} deletePostLocally={functions?.deletePostLocally} />;
      case VIEWTYPES.RELATEDPOSTS:
        return <RelatedPostsText />;
      case VIEWTYPES.POST:
        if (item?.lastHomeTs) {
          if (postType === "trending" && functions.setTrendingTs) functions.setTrendingTs(item?.lastHomeTs);else if (functions.setPostNewTs) functions.setPostNewTs(item?.lastHomeTs);
        }
        return <Post key={index.toString()} postData={item.feedPostModel || item.response} deletePostLocally={functions?.deletePostLocally} />;
      case VIEWTYPES.UTSAV_CLIPS:
        if (functions?.setReelNewTs && item.lastClipTs) functions.setReelNewTs(item.lastClipTs);
        return <Clips key={index.toString()} data={item} />;
      case VIEWTYPES.YOUTUBE_CLIPS:
        if (functions?.setPosition) functions.setPosition(getLastPosition(item.feedYoutubeLinkModels || props.data.response));
        return <YoutubeClips key={index.toString()} data={item} />;

      // case VIEWTYPES.HASHTAG:
      // -------------not in use currently----------
      //   return (
      //     <Trending
      //       key={index.toString()}
      //       data={item.hashtagModels || item.response}
      //     />
      //   );

      case VIEWTYPES.FESTIVAL_TYPE:
        return <Festivals key={index.toString()} data={item} />;
      case VIEWTYPES.FESTIVAL_TIMELINE:
        return <FestivalTimeline key={index.toString()} data={item} />;
      case VIEWTYPES.TIMER:
        return <Timer key={index.toString()} data={item.timerModels || item.response} />;
      default:
        return "";
    }
  }
  return <ViewSinglePostModalProvider data-sentry-element="ViewSinglePostModalProvider" data-sentry-component="RenderPosts" data-sentry-source-file="FeedsItems.jsx">
      {data.map(getFeedItem)}
    </ViewSinglePostModalProvider>;
}
function getLastPosition(array) {
  const last = array[array.length - 1];
  return last?.position;
}